"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormStepDefinitions = void 0;
const step_definition_1 = require("./normalized-ratings-form/step-definition");
const step_definition_2 = require("./normalized-signal-drive-modes-form/step-definition");
const step_definition_3 = require("./sigma-model-entry-form/step-definition");
exports.FormStepDefinitions = {
    NormalizedAmrsForm: step_definition_1.NormalizedAmrsFormDefinition,
    NormalizedOcsForm: step_definition_1.NormalizedOcsFormDefinition,
    NormalizedSignalDriveModesForm: step_definition_2.NormalizedSignalDriveModesFormDefinition,
    SigmaModelEntryForm: step_definition_3.SigmaModelEntryFormDefinition,
};
//# sourceMappingURL=form-steps.js.map